import * as React from 'react';
import * as learn from './style.module.scss';
export const Learn = () => {
  return (
    <section className={learn.learn}>
      <div className={`container ${learn.learn__container}`}>
        <div className={learn.learn__info}>
          <h2 className={learn.learn__title}>
            Думаете учиться уже поздно?
          </h2>
          <p className={learn.learn__description}>
            На самом деле, чем чаще вы будете тренировать свой мозг, тем дольше будете ясно мыслить. Более того, вы
            можете увеличить скорость запоминания. Убедитесь в этом сами, посмотрев небольшое видео.
          </p>
        </div>
        <div className={learn.learn__move}>
          <iframe
            src="https://www.youtube.com/embed/Oe4r_u9Ej9E"
            title="Техника запоминания иностранных слов за 2 минуты"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};
